<template>
	<v-app>
		<Header v-if="$router.currentRoute.name != 'login'" />

		<v-content>
			<v-container fluid mb-12 fill-height :align-start="$router.currentRoute.name != 'login'">
				<router-view></router-view>
			</v-container>
		</v-content>

		<Footer />
	</v-app>
</template>

<script>
	import Header from "@/components/Header"
	import Footer from "@/components/Footer"

    export default {
	name: 'App',
		components: {
			Header,
			Footer
		},
    }
</script>
